<template>
    <textarea
        :type="data.type"
        :id="inputFieldId"
        :name="name"
        :required="data.required"
        :class="'custom-scrollbar app-textarea ' + data.inputClass"
        :placeholder="data.placeholder"
        :readonly="data.readOnly"
        :disabled="data.disabled"
        :rows="data.textAreaRows"
        :cols="data.textAreaCols"
        :minlength="data.minlength"
        :maxlength="data.maxlength"
        :spellcheck="data.textAreaSpellCheck"
        :style="textareaStyle"
        v-bind:value="value"
        v-on="listeners">
    </textarea>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name: "TextArea",
    mixins: [InputMixin],
    computed: {
        textareaStyle() {
            return {
                direction: this.data.textAreaDir,
                minHeight: this.data.textAreaRows ? null : '7rem',
                resize: 'vertical',
                lineHeight: 1.6,
            };
        },
    },
}
</script>
